module.exports = __webpack_public_path__ + "static/img/drag.f00256e7.svg";